export const QuestionFilterElements = [
  {
    isMain: true,
    isShow: false,
    type: "inputSelect",
    valueName: "surveyType",
    label: "نوع نظرسنجی",
    options: "questionTypeSelect",
    WrapperClassName: "!filterInput",
  },
  {
    isMain: true,
    isShow: false,
    type: "inputSelect",
    valueName: "questionType",
    label: "نوع سوال",
    options: "questionAssessmentMethodSelect",
    WrapperClassName: "!filterInput",
  },
  {
    isMain: true,
    isShow: false,
    type: "inputSelect",
    valueName: "replyType",
    label: "نوع پاسخ",
    options: "replyTypeSelect",
    WrapperClassName: "!filterInput",
  },
]
